import React, { forwardRef } from "react";
import { TableCell, TableRow } from "@mui/material";
import { useNavigate } from "react-router";
import MenuComponent, { MenuItem } from "components/MenuComponent";
import { hasPermission } from "core/utils/roles";
import { Permissions } from "../../model";

interface TableRowProps {
  row: Permissions;
  attributes: { [key: string]: any };
}

const PermissionsRow = forwardRef<HTMLTableRowElement, TableRowProps>(
  (props, ref) => {
    const navigate = useNavigate();
    const row = props.row;
    const attributes = props.attributes;

    const options: MenuItem[] = [
      {
        label: hasPermission("update:permissions")
          ? "Edit Permission"
          : "View Permission",
        onClick: () => navigate(`/security/permissions/add-edit/${row.id}`),
      },
    ];

    return (
      <React.Fragment>
        <TableRow
          ref={ref}
          sx={{ borderBottom: "none", "& > *": { borderBottom: "unset" } }}
        >
          <TableCell>{row?.name}</TableCell>
          <TableCell>{row?.description}</TableCell>
          <TableCell>{row?.entity}</TableCell>
          <TableCell>
            {row?.created_at &&
              new Date(row.created_at).toLocaleString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
              })}
          </TableCell>
          <TableCell>
            <MenuComponent options={options} />
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }
);

export default PermissionsRow;
